import Opsional from './Opsional.vue'

export default Opsional
